<div class="tw-w-full tw-flex-col tw-gap-1 tw-flex">
  @if (label) {
    <div class="tw-flex tw-gap-1 tw-font-bold tw-text-dt-text-tertiary tw-z-10 tw-text-[12px]">
      <span class="tw-whitespace-nowrap" [ngClass]="labelClass">{{ label }}</span>
      <span *ngIf="isRequired" class="tw-text-sm">*</span>
    </div>
  }
  <div
    [attr.data-testid]="'date-picker' + (dateInputLabel ? '-' + dateInputLabel.toLowerCase() : '')"
    (click)="openDatePicker()"
    appKeyboardActivatable
    [appKeyboardActivatableDisabled]="isDisabled"
    [appKeyboardActivatableExpanded]="datePicker.opened"
    (appKeyboardActivatableActivate)="openDatePicker()"
    [ngClass]="{
      'input-error-border': hasError && isRequired && !isDisabled,
      '!tw-cursor-not-allowed tw-opacity-50 !tw-shadow-elevation-input': isDisabled,
      'tw-min-h-12 tw-px-5 tw-shadow-button': !compact,
      'tw-h-[24px] tw-px-2 tw-text-sm tw-shadow-elevation-input': compact,
    }"
    class="{{
      borderType ? borderType + '-round-border' : compact ? 'tw-rounded' : 'tw-rounded-lg'
    }} tw-flex tw-items-center tw-bg-color-surface-input tw-cursor-pointer"
  >
    <div class="tw-relative tw-flex tw-items-center tw-justify-center">
      <mat-datepicker #datePicker></mat-datepicker>
      <input
        matInput
        tabindex="-1"
        [matDatepicker]="datePicker"
        [value]="getDatePickerValue()"
        [matDatepickerFilter]="filterDates"
        (dateChange)="onDateChange($event)"
        class="tw-pointer-events-none tw-absolute tw-opacity-0 tw--left-12 sm:tw--left-24"
      />
      @if (dateInputLabel) {
        <span
          class="tw-font-medium tw-mr-2 sm:tw-mr-0 sm:tw-absolute sm:tw-top-0 sm:tw-left-0 sm:tw--mt-12 sm:tw--ml-5"
        >
          {{ dateInputLabel }}
        </span>
      }
    </div>
    <div class="tw-flex tw-items-center tw-flex-grow">
      <span
        class="tw-whitespace-nowrap"
        [ngClass]="{
          'tw-opacity-60': !dateText && !isDisabled,
          'tw-text-dt-text-secondary': isDisabled,
          'tw-text-dt-text-headings': !isDisabled,
          'tw-form-field-text': !compact,
        }"
      >
        {{ dateText || "YYYY-MM-DD" }}
      </span>
    </div>
    <div
      class="tw-overflow-hidden tw-rounded"
      *ngIf="hasIcon && !compact"
      [class.tw-invisible]="isDisabled"
    >
      <icon [name]="'calendar'" [size]="5" [currentColor]="'primary'"></icon>
    </div>
  </div>

  <mat-error
    class="error-inline input-error tw-mt-1"
    *ngIf="hasError && isRequired && showErrorText"
  >
    {{ "thisFieldIsRequired" | i18n }}
  </mat-error>
</div>
